import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_JWT_SECRET ;

export const encryptData = (data) => {
  try {
    const payload = typeof data === "string" ? data : JSON.stringify(data);
    return CryptoJS.AES.encrypt(payload, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};

export const decryptData = (cipherText) => {
  try {
    if (!cipherText) return null;
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    if (!decrypted) return null;

    // Try to parse as JSON (for objects); if it fails, it's a plain string
    try {
      return JSON.parse(decrypted);
    } catch {
      return decrypted;
    }
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};